import createCache from "@emotion/cache";
import rtlPlugin from "stylis-plugin-rtl";
import { prefixer } from "stylis";

export const createRtlCache = (isRTL: boolean) =>
  createCache({
    key: isRTL ? "muirtl" : "mui",
    stylisPlugins: isRTL ? [prefixer, rtlPlugin] : [],
  });